import HonjoFormRender from './HonjoFormRender.vue'

export { HonjoFormRender }
